/* Quiz — RJ-11 (Bible §22 · Q5 locked).
   One to five questions, reorderable, asked ONE AT A TIME on the customer’s
   side (batch 10) and every one of them skippable. The same builder serves a
   poll (one question) and private feedback (free text). Answers can never gate
   the Gift, and never route by sentiment. The disclosure line is fixed — it is
   not the merchant’s to edit. */
import { useNavigate } from 'react-router-dom'
import { Button, KV, ListRow } from '@/ui'
import { Retour } from './parts'

const QUESTIONS = [
  { id: 'q1', label: 'Q1 · Qu’est-ce qui vous ferait revenir plus souvent ?', meta: 'choix unique · 4 réponses · Passer : oui' },
  { id: 'q2', label: 'Q2 · Votre visite d’aujourd’hui ?', meta: 'échelle 1–5 · Passer : oui' },
]

export default function Quiz() {
  const nav = useNavigate()
  return (
    <div style={{ display: 'grid', gap: 16, maxWidth: 780 }}>
      <Retour />
      <div style={{ display: 'flex', alignItems: 'baseline', gap: 12, flexWrap: 'wrap' }}>
        <h2 className="t-page" style={{ margin: 0 }}>Quiz — «&nbsp;Découverte&nbsp;»</h2>
        <span className="f-help" style={{ marginLeft: 'auto' }}>enregistré 14:05</span>
      </div>

      <section>
        {QUESTIONS.map(q => (
          <ListRow key={q.id} title={q.label} meta={q.meta}
            end={<Button size="sm" variant="quiet"
              onClick={() => nav('/campagnes/parcours/quiz/question')}>modifier</Button>} />
        ))}
      </section>

      <div>
        <Button variant="quiet" size="sm">+ Ajouter une question (max 5)</Button>
      </div>

      <KV rows={[
        ['Intro client', '« Une question express pour {merchant}. »'],
        ['Ligne de transparence (fixe)', '« Vos réponses aident l’équipe. Conservées 24 mois, jamais partagées. »'],
        ['Côté client', 'une question à la fois — chacune passable, et le cadeau s’ouvre quand même'],
      ]} />

      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
        <Button size="sm" variant="quiet">Prévisualiser comme un client</Button>
        <Button size="sm" variant="primary" onClick={() => nav('/reponses?onglet=quiz')}>Ouvrir dans Demandes</Button>
      </div>
    </div>
  )
}
